import { isDefined } from "@clipboard-health/util-ts";

import { type WorkerInfoType, type WorkplaceCommentType } from "./api/useWorkplaceComments";

export const REDACTED_SENTINEL = "[REDACTED]";

export function isReviewRedacted(comment: WorkplaceCommentType): boolean {
  return comment.attributes.text === REDACTED_SENTINEL;
}

export function getPageCursor(cursorUrl: string): string | undefined {
  // eslint-disable-next-line prefer-destructuring
  const search = cursorUrl.split("?")[1];
  if (!isDefined(search)) {
    return undefined;
  }

  const searchParams = new URLSearchParams(search);

  return searchParams.get("page[cursor]") ?? undefined;
}

export function isViewerAuthor(params: { workerInfo: WorkerInfoType; viewerUserId: string }) {
  return params.workerInfo.isAuthor === true || params.workerInfo.id === params.viewerUserId;
}
